import Vue from "vue/dist/vue";
import VueScrollTo from "vue-scrollto";
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import lax from "lax.js";
import _ from "lodash";

Vue.component("ToggleButton", ToggleButton);

new Vue({
  el: "#app",
  data() {
    return {
      menu: null,
      veggieOnly: false,
      searchFor: "",
    };
  },

  mounted() {
    axios
      .get("data/menu.json")
      .then((response) => (this.menu = response.data.category))
      .then();
  },

  methods: {
    goto: function (destination) {
      VueScrollTo.scrollTo("#" + destination, {
        easing: "ease-in-out",
        duration: 1000,
      });
    },

    isVeggie: function (value) {
      return value == 1 ? "veggie" : 0;
    },

    showHideVeggie: function () {
      let items = document.querySelectorAll(".veggie > .menu-item");

      if (this.veggieOnly) {
        for (const item of items) {
          if (!item.classList.contains("veggie")) {
            item.style.display = "none";
          }
        }
      } else if (!this.veggieOnly) {
        for (const item of items) {
          item.style.display = "";
        }
      }
    },

    orderItems: function (items) {
      let searchFor = this.searchFor;

      // Check Price is a Num and round to 2
      _.each(items, function (item) {
        item.price = _.round(_.toNumber(item.price), 2);
      });

      //Check if search is On and Item is on Menu
      items = _.filter(items, function (n) {
        return (
          (n.desc_it + n.desc_fr + n.desc_en + n.desc_nl)
            .toLowerCase()
            .search(searchFor.toLowerCase()) > -1 && n.isOnMenu == 1
        );
      });

      return _.orderBy(items, "price", "asc");
    },

    clearSearchField: function () {
      this.searchFor = "";
    },

    fixed: function (value) {
      if (!value) return "";
      value = value.toFixed(2);
      return value;
    },

    highlight: function (sentence) {
      let searchFor = this.searchFor;
      let replace = new RegExp(searchFor, "gi");
      let highlited = sentence.replace(
        replace,
        "<span class='highlight'>" + searchFor + "</span>"
      );

      console.log(highlited);

      let result = searchFor != "" ? highlited : sentence;
      return result;
    },
  },

  created() {
    Vue.use(ToggleButton);
    window.onload = function () {
      lax.init();

      // Add a driver that we use to control our animations
      lax.addDriver("scrollY", function () {
        return window.scrollY;
      });

      lax.addElements("#home-logo", {
        scrollY: {
          rotate: [
            ["0", "elOutY"],
            [0, "360"],
          ],
          opacity: [
            ["0", "elOutY"],
            [1, "0"],
          ],
        },
      });

      lax.addElements(".grid-button", {
        scrollY: {
          opacity: [
            ["0", "elOutY"],
            [1, "0"],
          ],
        },
      });

      lax.addElements("#home-cards", {
        scrollY: {
          opacity: [
            ["0", "elOutY"],
            [1, "0"],
          ],
        },
      });

      lax.addElements("#navbar", {
        scrollY: {
          opacity: [
            ["0", "elOutY"],
            [0, "1"],
          ],
        },
      });
    };
  },
});
